import React, { ReactElement } from 'react';
import classnames from 'classnames';
import { PaginationProps } from '../Pagination';
import styles from './index.module.css';

export interface PaginationItemProps
  extends Pick<PaginationProps, 'size' | 'rounded'> {
  selected?: boolean;
  value: 'Previous' | 'Next' | number;
  disabled?: boolean;
  onClick: VoidFunction;
}

export function PaginationItem({
  size = 'default',
  selected = false,
  value,
  disabled = false,
  rounded = false,
  onClick,
}: PaginationItemProps): ReactElement {
  const classes = classnames(
    `${styles.button} ${styles[`button--${size}`]}`,
    { [styles['button--active']]: !!selected },
    { [styles['button--rounded']]: !!rounded },
  );

  return (
    <li>
      <button
        disabled={disabled}
        className={classes}
        onClick={selected ? undefined : onClick}
      >
        {value}
      </button>
    </li>
  );
}
